// extracted by mini-css-extract-plugin
module.exports = {"telephones":"styles_telephones__3Dy0Z","empty":"styles_empty__24_T5","telephone":"styles_telephone__PQhWW"};